// extracted by mini-css-extract-plugin
export default {"tool-icon":"Settings_tool-icon__TUYkd","minHeight":"Settings_minHeight__IJEwp"};